import './form.scss';
import { Box, Container, Grid, Link } from '@mui/material';
import axios from 'axios';
import emailjs from '@emailjs/browser';
import React, { useState } from "react";
import SEO from '../../seo/SEO';

function FormUpload() {


    const CLOUD_NAME = "zdoffaxg";
const UPLOAD_PRESET = "vrcontest";

const SERVICE_ID = "service_vvyg06w";
const TEMPLATE_ID = "template_s29gk4d";
const PUBLIC_KEY = "SyVfqUTQonxXjBZJC";


const [errors, setErrors] = useState({});
 const [loading, setLoading] = useState(false);

    const [video, setVideo] = useState(null);

    const [fileName, setFileName] = useState("");

    const [form, setForm] = useState({

        reelTitle: "",

        category: "",

        description: "",

        fullName: "",

        email: "",

        agree: false,

    });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
    }));

    setErrors((prev) => ({
        ...prev,
        [name]: "",
    }));
};

const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (file.size > 500 * 1024 * 1024) {
        setErrors((prev) => ({
            ...prev,
            video: "Maximum 500MB allowed.",
        }));
        return;
    }

    setVideo(file);
    setFileName(file.name);

    setErrors((prev) => ({
        ...prev,
        video: "",
    }));
};

const uploadVideo = async () => {
    try {
        const data = new FormData();

        data.append("file", video);
        data.append("upload_preset", UPLOAD_PRESET);

        const response = await axios.post(
            `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/video/upload`,
            data,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        console.log("Cloudinary Response:", response.data);

        return response.data.secure_url;

    } catch (err) {
        console.error("Cloudinary Error:", err.response?.data || err);
        throw err;
    }
};



const sendEmail = async (videoUrl) => {

    const templateParams = {
        reelTitle: form.reelTitle,
        category: form.category,
        description: form.description,
        fullName: form.fullName,
        email: form.email,
        video: videoUrl,
    };

    console.log("Sending:", templateParams);

    return emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        templateParams,
        PUBLIC_KEY
    );
};


const handleSubmit = async () => {

    if (!validate()) return;

    setLoading(true);

    try {

        // Upload Video to Cloudinary

        const videoUrl = await uploadVideo();
        console.log("Video URL:", videoUrl);
        // Send Email

        await sendEmail(videoUrl);

        alert("Submission Successful.");

        // Reset Form

        setForm({

            reelTitle: "",

            category: "",

            description: "",

            fullName: "",

            email: "",

            agree: false

        });

        setVideo(null);

        setFileName("");

        document.getElementById("videoUpload").value = "";

    }

    catch (err) {
    console.error("Email Error:", err);

    if (err.text) {
        alert(err.text);
    } else {
        alert("Something went wrong.");
    }
}

    finally {

        setLoading(false);

    }

};
const validate = () => {
    let newErrors = {};

    if (!video) {
        newErrors.video = "Please select a video.";
    }

    if (!form.reelTitle.trim()) {
        newErrors.reelTitle = "Please enter Reel Title.";
    }

    if (!form.category) {
        newErrors.category = "Please select Category.";
    }

    if (!form.description.trim()) {
        newErrors.description = "Please enter Description.";
    }

    if (!form.fullName.trim()) {
        newErrors.fullName = "Please enter Full Name.";
    }

    if (!form.email.trim()) {
        newErrors.email = "Please enter Email.";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
        newErrors.email = "Please enter a valid Email.";
    }

    if (!form.agree) {
        newErrors.agree = "Please accept competition rules.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
};



    return (
        <>
            <SEO pageKey="uploadForm" />
            <Box className="lockerBanner" >
                <Container maxWidth="md">
                    <Grid container spacing={2} justifyContent="left" alignItems="center">
                        <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                            <Box className="bannerText text-center">
                                <h1>Upload Your VR Reel</h1>
                                <span>One story. One world. One shot at India's next great mythology reel. Fill in the details, drop your file, and hit submit.</span>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <section className="upload-section">
    <Container maxWidth="md">
        <Grid container spacing={3} justifyContent="left">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>

                <form
                    className="reelForm"
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                >

                    {/* Section 01 */}
                    <div className="formSection">
                        <div className="sectionHeader">
                            <span className="step">01</span>
                            <h3>Your Reel</h3>
                        </div>

                        <div className="uploadArea">

                            <input
                                type="file"
                                hidden
                                id="videoUpload"
                                accept="video/mp4,video/quicktime,video/webm,.mp4,.mov,.webm"
                                onChange={handleFileChange}
                            />
                           

                            <label htmlFor="videoUpload">

                                <div className="iconBox">
                                    <i className="fa fa-cloud-upload"></i>
                                </div>

                                <h4>
                                    {fileName ? (
                                        <>
                                            Selected :
                                            <span> {fileName}</span>
                                        </>
                                    ) : (
                                        <>
                                            Drag & drop your video, or <span>Browse</span>
                                        </>
                                    )}
                                </h4>

                                <p>
                                    MP4, MOV, WEBM · Max 500MB · 60–180 seconds recommended
                                </p>

                            </label>

                        </div>
                         {errors.video && (
    <p className="error-text">{errors.video}</p>
)}
                    </div>

                    {/* Section 02 */}

                    <div className="formSection">

                        <div className="sectionHeader">
                            <span className="step">02</span>
                            <h3>Reel Details</h3>
                        </div>

                        <div className="sectionBody">

                            <div className="mb-4">

                                <label>REEL TITLE</label>

                                <input
                                    type="text"
                                    className="form-control customInput"
                                    name="reelTitle"
                                    value={form.reelTitle}
                                    onChange={handleChange}
                                />
                                {errors.reelTitle && (
    <p className="error-text">{errors.reelTitle}</p>
)}

                            </div>

                            <div className="mb-4">

                                <label>CATEGORY</label>

                                <select
                                    className="form-select customInput"
                                    name="category"
                                    value={form.category}
                                    onChange={handleChange}
                                >

                                    <option value="">Select Category</option>

                                    <option>VR180/360° - True VR / Immersive</option>

                                    <option>9:16 Cinematic - Mobile Immersive Reel</option>

                                    <option>Cinematic VFX</option>

                                    <option>AI + Unreal</option>

                                    <option>Temple Experiences</option>

                                    <option>Interactive - 360° Story Scene</option>

                                </select>

                                {errors.category && (
    <p className="error-text">{errors.category}</p>
)}

                            </div>

                            <div>

                                <label>SHORT DESCRIPTION</label>

                                <textarea
                                    rows="6"
                                    className="form-control customInput textarea"
                                    name="description"
                                    value={form.description}
                                    onChange={handleChange}
                                />
                                {errors.description && (
    <p className="error-text">{errors.description}</p>
)}

                            </div>

                        </div>

                    </div>

                    {/* Section 03 */}

                    <div className="formSection">

                        <div className="sectionHeader">
                            <span className="step">03</span>
                            <h3>About You</h3>
                        </div>

                        <div className="sectionBody">

                            <div className="row">

                                <div className="col-lg-6 mb-3">

                                    <label>FULL NAME</label>

                                    <input
                                        type="text"
                                        className="form-control customInput"
                                        name="fullName"
                                        value={form.fullName}
                                        onChange={handleChange}
                                    />

                                    {errors.fullName && (
    <p className="error-text">{errors.fullName}</p>
)}

                                </div>

                                <div className="col-lg-6 mb-3">

                                    <label>EMAIL</label>

                                    <input
                                        type="email"
                                        className="form-control customInput"
                                        name="email"
                                        value={form.email}
                                        onChange={handleChange}
                                    />
{errors.email && (
    <p className="error-text">{errors.email}</p>
)}
                                </div>

                            </div>

                        </div>

                    </div>

                    {/* Agreement */}

                    <div className="agreementBox">

                        <div className="form-check">

                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="agree"
                                name="agree"
                                checked={form.agree}
                                onChange={handleChange}
                            />

                            

                            <label
                                className="form-check-label"
                                htmlFor="agree"
                            >
                                I confirm this reel is my original work and I agree to the
                                <span> competition rules </span>
                                and content guidelines.
                            </label>

                            {errors.agree && (
    <p className="error-text">{errors.agree}</p>
)}

                        </div>

                    </div>

                    {/* Submit */}

                    <div className="submitBox">

                        <button
                            type="submit"
                            className="btn submitBtn"
                            disabled={loading}
                        >
                            {loading ? "Uploading..." : "Submit Your Reel"}
                        </button>

                        <p>
                            You'll receive a confirmation email once your submission is queued for review.
                        </p>

                    </div>

                </form>

            </Grid>
        </Grid>
    </Container>
</section>



        </>
    );
}
export default FormUpload;